/**
 * Video play script
 */
class ATS_UI {
    constructor() {
        ATS_UI.initVideoWithOverlay();
        ATS_UI.initSmoothScroll();
        ATS_UI.initVideoPopup();
        ATS_UI.initDataInfographics();
        ATS_UI.initPlaneInfographics();
    }

    static initVideoWithOverlay () {
        let videos = $('.video-wrapper .overlay');

        if (videos.length) {
            for (let i = 0; i < videos.length; i++) {
                let overlay = videos.eq(i);
    
                videos.eq(i).on('click', e => {
                    overlay.addClass('is-hidden');
                    let iframe = overlay.parent().find('iframe');
                    iframe[0].contentWindow.postMessage(JSON.stringify({
                        'event': 'command',
                        'func': 'playVideo',
                        'args': []
                    }), '*');
                });
            }
        }
    }

    static initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                }
            }
         });
    }

    static initVideoPopup () {
        let videoPopupWrapper = $('.video-popup-overlay');
        var openPopupBtn = $('.js-open-video-popup');
        var closeVideoPopup = videoPopupWrapper.find('.video-popup-close');
        let iframe = videoPopupWrapper.find('iframe');
        

        openPopupBtn.on('click', function (e) {
            e.preventDefault();
            videoPopupWrapper.removeClass('is-hidden');
            $(document.body).addClass('no-scroll');
        });

        closeVideoPopup.on('click', function (e) {
            e.preventDefault();
            videoPopupWrapper.addClass('is-hidden');
            $(document.body).removeClass('no-scroll');

            iframe[0].contentWindow.postMessage(JSON.stringify({
                'event': 'command',
                'func': 'pauseVideo',
                'args': []
            }), '*');
        });
    }

    static initDataInfographics () {
        if($('.block-infographics').length) {
            ATS_UI.getInfoData();
        
            $('.js-airport-select').select2().on("change", function(e) {
                ATS_UI.getInfoData();
            });
        }
    }

    static getInfoData () {
        let obj;
        let airportID;
        let endpointUrl = $('.js-airport-select').attr('data-endpoint');
        let parameterName = $('.parameter-name');
        let parameterVal = $('.parameter-val');
        let parameterValFull = $('.parameter-full-name');
        let airportDesc = $('.airport-desc');

        try {
            obj = $(".js-airport-select").select2("data");
            airportID = parseInt(obj[0].id, 10);
        } catch (e) {
            obj = $(".js-airport-select").val();
            airportID = parseInt(obj, 10);
        }

        $.ajax(endpointUrl + airportID).done((res) => {
            parameterName.removeClass('is-active');
            parameterVal.removeClass('is-active');
            airportDesc.removeClass('is-active');
            parameterValFull.removeClass('is-active');

            setTimeout(() => {
                $('.js-title-one').html(res.data.title_one);
                $('.js-value-one').text(res.data.value_one);
                $('.js-title-two').html(res.data.title_two);
                $('.js-value-two').text(res.data.value_two);
                $('.js-title-three').html(res.data.title_three);
                $('.js-value-three').text(res.data.value_three);
                $('.js-title-four').html(res.data.title_four);
                $('.js-value-four').text(res.data.value_four);
                $('.js-intro').text(res.data.intro);
            }, 625);

            setTimeout(() => {
                parameterName.addClass('is-active');
                parameterVal.addClass('is-active');
                airportDesc.addClass('is-active');
                parameterValFull.addClass('is-active');
            }, 750);
        });
    }

    static initPlaneInfographics () {
        if($('.block-plane-infographics').length) {
            $('.js-plane-select').select2().on("change", function(e) {
                var selectedModel = $(e.currentTarget);
                var selectModelVal = selectedModel.val();
                var planeSaving = $('.parameter-plane');
                var planeSavingLow = $('.parameter-plane.low');
                var planeSavingMedium = $('.parameter-plane.medium');
                var planeSavingHigh = $('.parameter-plane.high');

                if (selectModelVal === 'embraer' || selectModelVal === 'bombardier' || selectModelVal === 'fokker') {
                    planeSaving.removeClass('is-active');
                    setTimeout(() => {
                        planeSavingLow.addClass('is-active');
                    }, 450);
                } else if (selectModelVal === 'airbus' || selectModelVal === 'boeing-737') {
                    planeSaving.removeClass('is-active');
                    setTimeout(() => {
                        planeSavingMedium.addClass('is-active');
                    }, 450);
                } else {
                    planeSaving.removeClass('is-active');
                    setTimeout(() => {
                        planeSavingHigh.addClass('is-active');
                    }, 450);
                }
            });
        }
    }
}